import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import wizardActions from './Wizard.actions';
import wizardStore from './Wizard.store';
import {callAction} from 'client/framework';
import './wizard.scss';

/**
 *
 * The Wizard
 *    The Wizard component will translate steps provided via prop into a <ProgressDot> driven
 *    'wizard' component.
 *
 * How it is rendered and built
 *    The wizard is built through the steps prop. Each step provides some configuration
 *    that the wizard uses to build itself, as well as add some lifecycle controls areound
 *    advancing and retreating.
 *
 *    Minimally, a step just needs to provide a getContent method for the step to render.
 *
 *    The wizard will take care of rendering the <ProgressDot> component with sufficient
 *    action handling that will allow a user to advance and go backwards without anything
 *    additional.
 *
 *    However, There are lifecycle methods:
 *      The provided steps provide the following lifecycle methods:
 *        - canAdvance
 *             predicate function that determines if a user is able to
 *             leave the currently active step
 *
 *             canAdvance will PREVENT the wizard from advancing to the next
 *             step if it returns false.
 *        - onAdvance
 *             handler fired when a user advances to the next provided step,
 *             can be used for cleanup, etc.
 *        - onRetreat
 *             handler fired when a user 'retreats' or goes backwards
 *             in the wizard. Used for cleanup, etc.
 *
 *
 *     Again, getContent is the only required method.
 *
 *
 * Actions
 *    The wizard uses the progress dots as a control for advancing and
 *    retreating through the provided step list -- however, sufficiently clever
 *    developers also have access to our Wizards suite of actions allowing them to:
 *      - ADVANCE_STEP,
 *      - SET_ACTIVE_STEP
 *      - RETREAT_STEP
 *    from outside the wizard itself.
 */
export default class Wizard extends React.Component {
  static propTypes = {
    steps: ImmutablePropTypes.listOf(ImmutablePropTypes.map.isRequired)
    /* Contains({
        getContent: PropTypes.func.isRequired,
        canAdvance: PropTypes.func,
        canRetreat: PropTypes.func,
        onAdvance: PropTypes.func,
        onRetreat: PropTypes.func,
        breadcrumb: PropTypes.string
      })
    ).isRequired, */
  };

  constructor(props) {
    super(props);
    callAction(wizardActions.RESET_STEPS, this.props.steps);
  }

  UNSAFE_componentWillUpdate() {
    const movementHandler = wizardStore.getMovementHandler();
    if (movementHandler) {
      movementHandler();
      callAction(wizardActions.CLEAR_MOVEMENT_HANDLER);
    }
  }

  render() {
    const activeStep = wizardStore.getActiveStep();
    if (!activeStep) {
      return null;
    }

    const gottenContent = activeStep.get('getContent')();
    return (
      <div>
        <div className='wizard-navigation' />
        <div>{gottenContent && React.cloneElement(gottenContent, {})}</div>
      </div>
    );
  }
}
